export function organizerSelectionAllowed(steps, groups, index) {
    for (let previous = index - 1; previous >= 0; previous--) {
        if (!steps[previous]._destroy) return !!groups[previous]?.organizer;
    }
    return true;
}

export function requiresWorkflowDescendants(steps, groups, index) {
    const step = steps[index];
    return !step._destroy && !!step.auto_approval && !!groups[index]?.organizer &&
        steps.slice(index + 1).some(next => !next._destroy);
}

// Sandbox Collections are valid workflow steps, but a Sandbox Organizer can't
// receive forwarded assets (see WorkflowStep.organizer_mismatch_error). Step 0
// is always a source, so anything is pickable there.
export function workflowGroupSelectable(group, index) {
    return index === 0 || !(group.sandbox && group.organizer);
}
